import { Button, Heading } from '@tmov/design-system';
import PropTypes from 'prop-types';
import React from 'react';

const DrawerHeader = ({ clearFilters }) => (
  <>
    <Heading variant="h4" style={{ margin: 0 }}>
      Filtrar
    </Heading>
    <Button
      type="submit"
      form="filterForm"
      variant="text"
      onClick={clearFilters}
    >
      Limpar filtros
    </Button>
  </>
);

DrawerHeader.propTypes = {
  clearFilters: PropTypes.func.isRequired,
};

export { DrawerHeader };
